import { Box } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import Wrapper from "../../layout/wrapper/Wrapper";
import useFetch from "../../hooks/api/useFetch";
import { useParams } from "react-router-dom";
import MessageDetailsCard from "../../components/MessageDetailsCard/MessageDetailsCard";
import PurchaseRequestDetailsCard from "../../components/PurchaseRequestDetailsCard/PurchaseRequestDetailsCard";
import ApiLoader from "../../components/Loaders/ApiLoader";

const PurchaseRequestDetails = () => {
  const { id } = useParams();
  const { data, isError, isLoading, isSuccess, refetch, isRefetching } =
    useFetch(["purchase-request", id], `/admin/purchase/request/${id}`);
  console.warn("PurchaseRequestDetails", data);
  return (
    <Wrapper>
      <ApiLoader loading={isLoading || isRefetching} />
      <Box className="main_body">
        <Box className={`commonBox ${styles.messageCommnBox}`}>
          <PurchaseRequestDetailsCard
            purchaseRequest={data?.data?.data}
            refetchPurchaseRequestData={refetch}
            isLoading={isLoading}
            isRefetching={isRefetching}
          />
        </Box>
      </Box>
    </Wrapper>
  );
};

export default PurchaseRequestDetails;
